module.exports = __webpack_public_path__ + "static/media/webappDesktopProfile.a9e94b2c.png";